import {
  NS_CONFIGURATION, PROJECT,
  VIEWER,
} from 'redux/constants';

import {
  action,
  createType,
  SELF,
  SYNC,
  ASYNC,
} from 'redux-create-type';

export const {
  INIT,
  INVALIDATE,
  SEARCH,
  SET_COMPANY,
  SET_PROJECT_LIST,
} = createType(NS_CONFIGURATION, PROJECT, VIEWER)({
    INIT: {
      [SELF]: ASYNC,
      COMPANY: ASYNC,
    },
    INVALIDATE: ASYNC,
    SEARCH: SYNC,
    SET_COMPANY: SYNC,
    SET_PROJECT_LIST: SYNC,
  });

export const init = {
  begin: () => action(INIT.BEGIN),
  end: ({ initParams }) => action(INIT.END, { initParams }),
  company: {
    begin: ({ values }) => action(INIT.COMPANY.BEGIN, { values }),
    end: ({ companyOptions, selectedCompany }) => action(INIT.COMPANY.END, { companyOptions, selectedCompany }),
  },
};
export const invalidate = {
  begin: () => action(INVALIDATE.BEGIN),
  end: ({ items }) => action(INVALIDATE.END, { items }),
};
export const search = () => action(SEARCH);
export const setCompany = companyId => action(SET_COMPANY, { companyId });
export const setProjectList = ({ values }) => action(SET_PROJECT_LIST, { values });



// WEBPACK FOOTER //
// ../redux/store/configuration/project/viewer/actions.js